import React from 'react';
import '../../css/pages/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1 className="privacy-policy-title">SmartGPT Tag Assistant Privacy Policy</h1>
      <div className="privacy-policy-content">
        <p><strong>Last Updated: June 27, 2025</strong></p>
        
        <h2>Introduction</h2>
        <p>This Privacy Policy describes how SmartGPT Tag Assistant Extension collects, uses, and protects your information when you use our Chrome extension. We are committed to protecting your privacy and being transparent about our data practices.</p>
        
        <h2>Information We Collect</h2>
        <h3>Personal Information</h3>
        <ul>
          <li><strong>Google Account Information:</strong> When you sign in through Google, we collect:
            <ul>
              <li>Email address</li>
              <li>Display name</li>
              <li>Google user ID (for authentication purposes)</li>
            </ul>
          </li>
          <li><strong>User Profile Data:</strong> Plan type (FREE, PRO, PRO+), subscription status, and expiry dates</li>
        </ul>
        
        <h3>Usage Information</h3>
        <ul>
          <li><strong>Prompt Usage Data:</strong> Number of prompts used, remaining quota, and usage timestamps</li>
          <li><strong>Plan Reset Data:</strong> Monthly reset timestamps and quota refresh information</li>
          <li><strong>Extension Activity:</strong> Information about when and how you use the extension's features</li>
        </ul>
        
        <h3>Technical Information</h3>
        <ul>
          <li><strong>Browser Data:</strong> Limited browser information necessary for extension functionality</li>
          <li><strong>Firebase Authentication Tokens:</strong> Secure tokens for maintaining your logged-in status</li>
        </ul>
        
        <h2>How We Use Your Information</h2>
        <h3>Core Functionality</h3>
        <ul>
          <li><strong>Authentication:</strong> Verify your identity and maintain secure access to your account</li>
          <li><strong>Plan Management:</strong> Track your subscription tier (FREE, PRO, PRO+) and enforce usage limits</li>
          <li><strong>Quota Tracking:</strong> Monitor prompt usage and apply appropriate restrictions based on your plan</li>
          <li><strong>AI Processing:</strong> Process your input text through our AI systems to generate tag replacements</li>
        </ul>
        
        <h3>Service Management</h3>
        <ul>
          <li><strong>Account Management:</strong> Manage your user profile and subscription status</li>
          <li><strong>Plan Resets:</strong> Automatically reset quotas monthly and manage plan expiration</li>
        </ul>
        
        <h2>Data Storage and Security</h2>
        <h3>Firebase Integration</h3>
        <ul>
          <li><strong>Secure Storage:</strong> Your data is stored securely using Google Firebase infrastructure</li>
          <li><strong>Encryption:</strong> All data transmission is encrypted using industry-standard protocols</li>
          <li><strong>Access Control:</strong> Strict access controls ensure only authorized systems can access your data</li>
        </ul>
        
        <h3>Chrome Extension Storage</h3>
        <ul>
          <li><strong>Local Storage:</strong> Limited data is stored locally in your browser for performance optimization</li>
          <li><strong>Sync Storage:</strong> Some preferences may be synced across your Chrome browsers when signed in</li>
        </ul>
        
        <h2>Data Sharing and Third Parties</h2>
        <h3>Google Services</h3>
        <ul>
          <li><strong>Firebase:</strong> We use Google Firebase for authentication, database, and cloud functions</li>
          <li><strong>Google Sign-In:</strong> Authentication is handled through Google's secure OAuth system</li>
        </ul>
        
        <h3>AI Processing</h3>
        <ul>
          <li><strong>AI Services:</strong> We use third-party AI services to process your input text and generate responses. Only the necessary prompt data is shared for processing.</li>
          <li><strong>Data Minimization:</strong> We only share the minimum necessary data required for AI processing</li>
        </ul>
        
        <h3>No Data Sale</h3>
        <p>We do not sell, rent, or trade your personal information to third parties for marketing purposes</p>
        
        <h2>Your Rights and Choices</h2>
        <h3>Account Control</h3>
        <ul>
          <li><strong>Access:</strong> You can view your account information through the extension dashboard</li>
        </ul>
        
        <h3>Opt-Out Options</h3>
        <ul>
          <li><strong>Extension Removal:</strong> You can uninstall the extension at any time</li>
        </ul>
        
        <h2>Children's Privacy</h2>
        <p>Our extension is not intended for use by children under 13 years of age. We do not knowingly collect personal information from children under 13. If we become aware that we have collected personal information from a child under 13, we will take steps to delete such information promptly.</p>
        
        <h2>Data Retention</h2>
        <p>We retain your personal and usage data only for as long as necessary to deliver our services and fulfill legal or regulatory requirements. You may contact us at any time to request deletion of your data, and we will respond promptly in accordance with applicable laws.</p>
        
        <h2>Refunds and Cancellations</h2>
        <p>Please note that we do not offer refunds or cancellations for any subscriptions, payments, or services purchased through our Chrome extension Or Website. All payments made are final and non-refundable, including in cases of:</p>
        <ul>
          <li>Accidental purchases</li>
          <li>Unused subscriptions</li>
          <li>User dissatisfaction</li>
          <li>Feature limitations</li>
        </ul>
        <p>We encourage you to try the free version (if available) before making a payment. If you experience technical issues, please contact us at pixelinnovators.21@gmail.com, and we will do our best to resolve the problem.</p>

        <h2>Changes to This Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time. When we make changes:</p>
        <ul>
          
          <li><strong>Effective Date:</strong> Changes become effective on the date specified in the updated policy</li>
          <li><strong>Continued Use:</strong> Your continued use of the extension after changes indicates acceptance</li>
        </ul>
        
        <h2>Contact Information</h2>
        <p>If you have questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at:</p>
        <p>Email:pixelinnovators.21@gmail.com</p>
        
        
        <h2>Permissions Explanation</h2>
        <ul>
          <li><strong>Storage Permission</strong>
            <ul>
              <li><strong>Purpose:</strong> Store user preferences, authentication tokens, and usage data locally</li>
              <li><strong>Data:</strong> User settings, login status, quota information</li>
            </ul>
          </li>
          <li><strong>Scripting Permission</strong>
            <ul>
              <li><strong>Purpose:</strong> Inject functionality into web pages to detect and replace AI tags</li>
              <li><strong>Scope:</strong> Limited to tag detection and replacement functionality</li>
            </ul>
          </li>
          <li><strong>Host Permissions (Firebase)</strong>
            <ul>
              <li><strong>Purpose:</strong> Communicate with Firebase services for authentication and data management</li>
              <li><strong>Scope:</strong> Limited to necessary Firebase endpoints only</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicy;